import React from "react";
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import InputLabel from '@mui/material/InputLabel';
import ClearIcon from '@mui/icons-material/Clear';
import { convertAmount } from './utils';

export default function AddDynamicInputFields( {result=[], callback} ) {
    //console.log(result)
    //console.log(callback)
    const [inputs, setInputs] = React.useState([]);
    const [isDisabled, setIsDisabled] = React.useState(true); // initial value is true
    //const [result, setResult] = React.useState({...result})

    const setBalance = (event) => {
        //basisObj.dateFormat = event.target.value;
        //setDateFormat(event.target.value);
        var data = [];
        for (let i = 0; i < inputs.length; i++) {
            //console.log(inputs[i])
            let am = inputs[i].amount.replace(/,/, '').trim()
            let rt = inputs[i].rate.replace(/,/, '').trim()
            if (am.length > 0 && rt.length > 0) {
                inputs[i].amount = am;
                inputs[i].rate = rt;
                inputs[i].date = i+"";
                inputs[i].fucurrency = am*rt;
                data.push(inputs[i])
            } // else ignore it
        }
        if (data.length === 0) {
            alert("Invalid opening balance data...");
            return false;
        }
        // add to the - call back with data
        //console.log(data);
        // convert it to an array
        var ob = []
        for (let i=0; i < data.length; i++) {
            ob.unshift([data[i].date, data[i].description, convertAmount(data[i].amount,2), convertAmount(data[i].rate,6), convertAmount(data[i].fucurrency,6)])
        }
        //console.log(result);
        //console.log('Opening balance'+ JSON.stringify(ob));
        let res = []
        if (document.getElementById("result-copy").value !== null) {
            res = JSON.parse(document.getElementById("result-copy").value);
        }
        callback(res, ob);
    }

    const handleAddInput = () => {
        setIsDisabled(false)
        setInputs([...inputs, { description: "Opening balance", amount: "", rate: "" }]);
    };

    const handleChange = (event, index) => {
        let { name, value } = event.target;
        let onChangeValue = [...inputs];
        onChangeValue[index][name] = value;
        setInputs(onChangeValue);
    };

    const handleDeleteInput = (index) => {
        const newArray = [...inputs];
        newArray.splice(index, 1);
        setInputs(newArray);
        if (inputs.length === 1) {
            setIsDisabled(true);
        }

        // Re-build OB from the remaining entries and re-apply immediately,
        // so the table reflects the deletion without needing a manual "Set Balance" click.
        var data = [];
        for (let i = 0; i < newArray.length; i++) {
            let am = newArray[i].amount.replace(/,/, '').trim();
            let rt = newArray[i].rate.replace(/,/, '').trim();
            if (am.length > 0 && rt.length > 0) {
                newArray[i].date = i + "";
                newArray[i].fucurrency = am * rt;
                data.push(newArray[i]);
            }
        }
        var ob = [];
        for (let i = 0; i < data.length; i++) {
            ob.unshift([data[i].date, data[i].description, convertAmount(data[i].amount, 2), convertAmount(data[i].rate, 6), convertAmount(data[i].fucurrency, 6)]);
        }
        let res = [];
        if (document.getElementById("result-copy").value !== null) {
            res = JSON.parse(document.getElementById("result-copy").value);
        }
        callback(res, ob);
    };

    return (
        <React.Fragment>
            <Grid container item xs={12}>
            <Grid item xs={5} sx={{ m: 1 }}>
                <b>Opening Balance</b>
                <div style={{ fontWeight: 'normal', fontSize: '0.875rem', color: '#555' }}>Enter balances in oldest to youngest order</div>
            </Grid>

            <Grid item xs={3} sx={{ ml: 4, mt: 1, mb: 1 }}>
                <FormControl fullWidth>
                    <Button sx={{
                        height: '25px'
                    }}
                        component="label"
                        size="small"
                        role={undefined}
                        variant="contained"
                            //onClick={addBalance}
                            onClick={() => handleAddInput()}
                    >
                        Add
                    </Button>
                </FormControl>
            </Grid>
            <Grid item xs={3} sx={{ m: 1 }}>
                <FormControl fullWidth>
                    <Button sx={{
                        height: '25px'
                    }}
                        disabled={isDisabled}
                        component="label"
                        size="small"
                        role={undefined}
                        variant="contained"
                        onClick={setBalance}
                    >
                        Set Balance
                    </Button>
                </FormControl>
            </Grid>
                        </Grid>

            {inputs.map((item, index) => (
                <Grid container className="input_container" key={index} alignItems="center" justifyContent="center">
                    <FormControl xs={1} sx={{
                        mb: 1,
                        pt: 1,
                        textAlign: "right",
                        fieldset: { border: 0 }
                    }}>
                                <TextField
                            //id="csvfile-id"
                            //label="Foreign amount"
                            name="index"
                            disabled
                            type="text"
                            value={index}
                            size="small"
                            inputProps={{ style: { textAlign: 'right', width: "30px" } }} // the change is here
                        />
                    </FormControl>
                    <FormControl xs={3} sx={{
                        pr: 1,
                    }}>
                        <TextField
                            //id="csvfile-id"
                                    label="Description"
                                    name="description"
                                    type="text"
                                    value={item.description}
                            size="small"
                            onChange={(event) => handleChange(event, index)}
                        //inputProps={{ style: { mr:2, pr:2 } }} // the change is here
                                />
                            </FormControl>
                    <FormControl xs={3} >
                                <TextField
                                    //id="csvfile-id"
                                    label="Foreign amount"
                                    name="amount"
                                    type="text"
                            value={item.amount}
                                    size="small"
                            onChange={(event) => handleChange(event, index)}
                                    inputProps={{ style: { textAlign: 'right' } }} // the change is here
                                />
                            </FormControl>
                    <FormControl xs={3} sx={{ ml: 2 }}>
                                <TextField
                            //id="csvfile-id"
                                    label="Rate"
                                    name="rate"
                                    type="text"
                            value={item.rate}
                                    size="small"
                            onChange={(event) => handleChange(event, index)}
                                    inputProps={{ style: { textAlign: 'right' } }} // the change is here
                                />
                            </FormControl>
                    {inputs.length > 0 && (
                        <Button sx={{
                            border: "none",
                            cursor: "pointer",
                            color: "black",
                            pt: 1,
                        }}
                            size="small"
                            onClick={() => handleDeleteInput(index)}><ClearIcon />
                        </Button>
                    )}
                        </Grid>
                ))}
            { /*<div className="body"> {JSON.stringify(inputs)} </div>*/}
        </React.Fragment>
    );
}

/* Style buttons */
// .btn {
//    background-color: DodgerBlue; /* Blue background */
//    border: none; /* Remove borders */
//    color: white; /* White text */
//    padding: 12px 16px; /* Some padding */
//    font-size: 16px; /* Set a font size */
//    cursor: pointer; /* Mouse pointer on hover */
//  }
//
//  /* Darker background on mouse-over */
//  .btn:hover {
//    background-color: RoyalBlue;
//  }